// test1620
(1620 && 0);
